/** @format */
import { useEffect, useState } from 'react';

export function useSessionStorage<T>(key: string, initialValue: T) {
    /*
     * State to store our value
     * Pass initial state function to useState so logic is only executed once
     */
    const [storedValue, setStoredValue] = useState(initialValue);

    useEffect(() => {
        try {
            // Get from session storage by key
            const value = window.sessionStorage.getItem(key);
            if (value) {
                // Parse stored json or if none return initialValue
                setStoredValue(JSON.parse(value));
            }
        } catch (error) {
            console.error(error);
        }
    }, []);

    useEffect(() => {
        window.sessionStorage.setItem(key, JSON.stringify(storedValue));
    }, [storedValue]);

    return [storedValue, setStoredValue] as const;
}
